import request from "../utils/requestConfig";
export const uploadAvatarR = (params = {}) => {
    return request.post(`/config-client/upload/`, params);
};